import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "messages scrollable",
  ref: "messages"
}
const _hoisted_2 = {
  key: 0,
  class: "chat-errors"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PinnedMessages = _resolveComponent("PinnedMessages")!
  const _component_Message = _resolveComponent("Message")!
  const _component_NotificationBanner = _resolveComponent("NotificationBanner")!
  const _component_MentionInput = _resolveComponent("MentionInput")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SmileIcon = _resolveComponent("SmileIcon")!
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!
  const _component_SendMessage = _resolveComponent("SendMessage")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["messages-container", { 'has-giveaway-banner': _ctx.hasGiveawaysBanner }])
  }, [
    _createVNode(_component_PinnedMessages),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createBlock(_component_Message, {
          user: _ctx.user,
          key: message.id,
          message: message,
          isLastMessageFromSameUser: _ctx.isLastMessageFromSameUser(message, index),
          isPrevMessageUserSame: _ctx.isPrevMessageUserSame(message, index)
        }, null, 8, ["user", "message", "isLastMessageFromSameUser", "isPrevMessageUserSame"]))
      }), 128))
    ], 512),
    (_ctx.chatErrors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatErrors, (chatError) => {
            return (_openBlock(), _createBlock(_component_NotificationBanner, {
              key: chatError.message
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chatError.message), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "message-input",
      ref: "formRef",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
    }, [
      _createVNode(_component_MentionInput, {
        ref: "mentionInput",
        disabled: !_ctx.user.id,
        modelValue: _ctx.text,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
        asyncSearch: _ctx.searchUsers,
        onSubmit: _cache[1] || (_cache[1] = () => _ctx.$refs.formRef.requestSubmit())
      }, null, 8, ["disabled", "modelValue", "asyncSearch"]),
      _withDirectives(_createVNode(_component_Button, {
        onClick: _cache[2] || (_cache[2] = () => _ctx.scrollToBottom(true)),
        class: "show-last",
        type: "primary",
        style: {"width":"20px","height":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Arrow)
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.isScrolled]
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_SmileIcon, {
          ref: "emojiToggle",
          style: {"cursor":"pointer"},
          "disable-skin-tone": true,
          onClick: _ctx.toggleEmojiPicker
        }, null, 8, ["onClick"]),
        (_ctx.emojiToggleEl)
          ? _withDirectives((_openBlock(), _createBlock(_component_EmojiPicker, {
              key: 0,
              style: {"position":"absolute","bottom":"40px","left":"0"},
              native: true,
              onSelect: _ctx.onSelectEmoji,
              theme: "dark"
            }, null, 8, ["onSelect"])), [
              [_vShow, _ctx.showEmojiPicker],
              [_directive_click_outside, {
            handler: _ctx.closeEmojiPicker,
            exclude: _ctx.emojiToggleEl,
          }]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          disabled: !_ctx.user.id,
          action: "submit",
          type: "empty",
          style: {"width":"20px","height":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SendMessage)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 544)
  ], 2))
}